(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dirath-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var grid = root.querySelector('[data-plp-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-colour]'));
    var countEl = root.querySelector('[data-plp-count]');

    root.querySelectorAll('[data-colour-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-colour-filter]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var want = btn.getAttribute('data-colour-filter');
        var shown = 0;
        cards.forEach(function (card) {
          var match = want === 'all' || card.getAttribute('data-colour') === want;
          card.hidden = !match;
          if (match) shown++;
        });
        if (countEl) countEl.textContent = shown;
      });
    });

    root.querySelectorAll('[data-size-preselect]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-size-preselect]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var size = btn.getAttribute('data-size-preselect');
        cards.forEach(function (card) {
          var radios = card.querySelectorAll('.dirath-size__input');
          radios.forEach(function (r) {
            if (r.value === size) { r.checked = true; }
          });
        });
      });
    });

    root.querySelectorAll('[data-view-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-view-btn]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        grid.classList.toggle('is-rail', btn.getAttribute('data-view-btn') === 'rail');
      });
    });
  }
  function boot() { document.querySelectorAll('.dirath-plp').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.dirath-plp').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dirath-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var alert = root.querySelector('[data-contact-alert]');
    if (alert) alert.focus();
  }
  function boot() { document.querySelectorAll('.dirath-contact').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.dirath-contact').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dirath-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var mainImg = root.querySelector('[data-pdp-mainimg]');
    root.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-pdp-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (mainImg) mainImg.src = btn.getAttribute('data-pdp-thumb');
      });
    });

    var priceEl = root.querySelector('[data-pdp-price]');
    var priceBtnEl = root.querySelector('[data-pdp-price-btn]');
    root.querySelectorAll('[data-pdp-size-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var price = input.getAttribute('data-variant-price');
        if (!price) return;
        if (priceEl) priceEl.textContent = price;
        if (priceBtnEl) priceBtnEl.textContent = price;
      });
    });
  }
  function boot() { document.querySelectorAll('.dirath-pdp').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.dirath-pdp').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dirath-size-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    var calc = section.querySelector('[data-size-calc]');
    if (!calc) return;
    var sizes = (calc.dataset.sizes || '').split(',').map(function (n) { return parseInt(n, 10); }).filter(function (n) { return !isNaN(n); }).sort(function (a, b) { return a - b; });
    if (!sizes.length) sizes = [28, 30, 32, 34, 36];

    var range = calc.querySelector('[data-waist-range]');
    var waistLabel = calc.querySelector('[data-waist-label]');
    var sizeOutput = calc.querySelector('[data-size-output]');
    var sizeNote = calc.querySelector('[data-size-note]');
    var shopLink = calc.querySelector('[data-shop-link]');
    if (!range) return;

    function nearestSize(waist) {
      // Round down to the nearest even inch, then clamp to an available size.
      var even = waist % 2 === 0 ? waist : waist - 1;
      var best = sizes[0];
      for (var i = 0; i < sizes.length; i++) {
        if (sizes[i] <= even) best = sizes[i];
      }
      if (even < sizes[0]) best = sizes[0];
      if (even > sizes[sizes.length - 1]) best = sizes[sizes.length - 1];
      return best;
    }

    function update() {
      var waist = parseInt(range.value, 10);
      if (waistLabel) waistLabel.textContent = waist + '″';
      var size = nearestSize(waist);
      if (sizeOutput) sizeOutput.textContent = size;
      if (sizeNote) {
        sizeNote.textContent = waist < sizes[0]
          ? 'Smaller than our smallest belt (' + sizes[0] + '). Get in touch and we will see what we can do.'
          : (waist > sizes[sizes.length - 1]
            ? 'Larger than our largest belt (' + sizes[sizes.length - 1] + '). Get in touch and we will see what we can do.'
            : 'Order this size in any of our three leathers.');
      }
      if (shopLink) shopLink.textContent = 'Shop size ' + size;
    }

    range.addEventListener('input', update);
    range.addEventListener('change', update);
    update();
  }
  function boot() { document.querySelectorAll('.dirath-sizeguide').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.dirath-sizeguide').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var toggle = root.querySelector('.dirath-toggle');
    var grid = root.querySelector('[data-products]');
    if (!toggle || !grid) return;
    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-view]');
      if (!btn) return;
      toggle.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      grid.classList.toggle('is-grid', btn.dataset.view === 'grid');
      grid.classList.toggle('is-rail', btn.dataset.view === 'rail');
    });
  }
  function boot() { document.querySelectorAll('.dirath-featured').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.dirath-featured').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-craft-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    var track = section.querySelector('[data-craft-track]');
    var bar = section.querySelector('[data-craft-bar]');
    var idx = section.querySelector('[data-craft-index]');
    var panels = parseInt(section.getAttribute('data-panels'), 10) || 1;
    if (!track || panels < 2 || reduce.matches) return;

    section.classList.add('is-pinned');

    var shift = (panels - 1) * (100 / panels); // % of the track's own width
    var lastTop = null;
    var lastStage = -1;

    // Horizon's layout scrolls inside `.page-wrapper` (overflow: hidden on
    // html/body), not the window — so `window.scrollY` never changes and
    // gating the frame loop on it freezes progress on stage one forever.
    // getBoundingClientRect() is viewport-relative regardless of which
    // ancestor actually scrolls, so re-reading it every frame (and gating
    // on ITS value instead) works no matter what scrolls the page.
    function frame() {
      var rect = section.getBoundingClientRect();
      if (rect.top !== lastTop) {
        lastTop = rect.top;
        var total = section.offsetHeight - window.innerHeight;
        var p = total > 0 ? -rect.top / total : 0;
        p = Math.max(0, Math.min(1, p));
        track.style.transform = 'translate3d(' + -shift * p + '%,0,0)';
        if (bar) bar.style.width = (p * 100).toFixed(2) + '%';
        var stage = Math.min(panels - 1, Math.round(p * (panels - 1)));
        if (idx && stage !== lastStage) {
          lastStage = stage;
          idx.textContent = ('0' + (stage + 1)).slice(-2);
        }
      }
      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  }

  function boot() {
    document.querySelectorAll('[data-craft-pin]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-craft-pin]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
